import { Box, Divider, Stack, Typography, TextField, Link } from '@mui/material';
import React, { useState } from 'react';

export default function List({ items, searchText='Search...' , updatedText='Updated on ' }) {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredItems = items
        .filter(item =>
            item.name.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => {
            const dateA = new Date(a.updated);
            const dateB = new Date(b.updated);
            return dateB - dateA; // Sort in descending order (newest first)
        });

    return (
        <Stack
            sx={{ p: 2, pt: 5 }}
            gap={2}
            divider={<Divider sx={{ borderColor: '#2f353d' }} />}
        >
            {/* GitHub-style search bar */}
            <TextField
                placeholder={searchText}
                variant="outlined"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                    input: {
                        padding: '6px 8px',
                        color: '#9198a1',
                        fontFamily: 'inherit',
                        fontSize: '14px'
                    },
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: 'transparent',
                        borderRadius: 1,
                        '& fieldset': {
                            borderColor: '#3d444d'
                        },
                        '&:hover fieldset': {
                            borderColor: '#8b949e'
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#58a6ff'
                        }
                    }
                }}
            />

            {/* List of items */}
            {filteredItems.map((item) => (
                <Stack key={item.name} spacing={1}>
                    {/* Name as link */}
                    <Link
                        href={item.link}
                        color="#58a6ff"
                        underline="hover"
                        variant="h6"
                        sx={{ fontFamily: 'inherit' }}
                        rel="noopener noreferrer"
                    >
                        {item.name}
                    </Link>

                    {/* Description */}
                    <Typography
                        color="#8c929b"
                        variant={'s6'}
                        fontFamily={'inherit'}
                        sx={{ overflow: 'ellipsis', fontFamily: 'inherit' }}
                    >
                        {item.description}
                    </Typography>

                    {/* Language dot and updated date */}
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Box
                                sx={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: '50%',
                                    bgcolor: item.color || 'rgba(0,0,0,0)' // fallback color
                                }}
                            />
                            <Typography color="#8c929b" fontSize={12} fontFamily={'inherit'}>
                                {item.language || ''}
                            </Typography>
                        </Stack>
                        <Typography color="#8c929b" fontSize={12} fontFamily={'inherit'}>
                            {item.updated ? updatedText + item.updated : ''}
                        </Typography>
                    </Stack>
                </Stack>
            ))}
        </Stack>
    );
}
